import React from "react";
import "../styles/InfoDocumentos.css";
import { useAuth } from "../context/AuthContext.jsx";
import FileManager from "./FileManager.jsx";
import { FileText } from 'lucide-react';

const InfoDisposiciones = () => {
  const { isAdmin } = useAuth();
  return (
      <div className="doc-page-container" style={{'--doc-color': '#283593', '--doc-bg-color': '#e8eaf6'}}>
        <div className="doc-page-card">
          <div className="doc-page-header">
            <div className="doc-page-icon"><FileText size={48} /></div>
            <h2 className="doc-page-title">Disposiciones</h2>
          </div>
          <p className="doc-page-text">Archivo digital de disposiciones de la <strong>Comuna de Santo Domingo</strong>.</p>
          <FileManager tableName="disposiciones_files" folderName="disposiciones" bucketName="disposiciones" isAdmin={isAdmin} />
        </div>
      </div>
  );
};
export default InfoDisposiciones;